import styled from "styled-components";
export const Container = styled.div `
  width: 585px;
  max-width: 100%;
  margin: 0 auto;
  padding: 40px 30px 32px 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    justify-content: flex-start;
    align-items: flex-start;
    padding: 40px 0px 5px 0px;
  }
`;
export const IconWrapper = styled.div `
  width: 52px;
  height: 52px;
  border-radius: 12px;
  border: 0.3px solid rgba(10, 13, 18, 0.12);
  background: #fff;
  box-shadow: 0 -0.75px 0.75px 0 rgba(10, 13, 18, 0.1) inset,
    0 1.5px 1.5px -0.75px rgba(10, 13, 18, 0.13),
    0 1.5px 4.5px 0 rgba(10, 13, 18, 0.1), 0 1.5px 3px 0 rgba(10, 13, 18, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px auto;
  position: relative;

  @media (max-width: 768px) {
    margin: 0px 0px 24px 0px;
    width: 45px;
    height: 45px;

    svg {
      width: 28px;
      height: 28px;
    }
  }
`;
export const Heading = styled.h1 `
  color: var(--Gray-900, #181d27);
  text-align: center;
  font-family: Inter;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.72px;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    text-align: left;
    font-size: 24px;
    font-style: normal;
    line-height: 32px;
  }
`;
export const SupportingText = styled.p `
  font-family: "Inter", sans-serif;
  font-size: 16px;
  color: #535862;
  text-align: center;
  margin-bottom: 85px;
  line-height: 24px;

  @media (max-width: 768px) {
    text-align: left;
    margin-bottom: 45px;
  }
`;
export const Checklist = styled.ul `
  list-style: none;
  padding: 0;
  margin: 0 0 32px 0;
  width: 100%;
`;
export const ChecklistItem = styled.li `
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  font-size: 16px;
  color: #414651;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  line-height: 24px;
`;
export const Checkbox = styled.span `
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: #f9f5ff;
  border: 1.5px solid #662d91;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
  margin-top: 5px;
  box-shadow: 0 0 0 2px rgba(171, 121, 210, 0.25);

  &::after {
    content: "";
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #662d91;
  }
`;
export const FooterText = styled.div `
  font-family: "Inter", sans-serif;
  font-size: 16px;
  color: #000;
  text-align: left;
  margin: 32px 0 69px 0;

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    margin: 32px 0 0px 0;
  }
`;
export const PrimaryButton = styled.button `
  width: 100%;
  max-width: 424px;
  height: 44px;
  background: ${(props) => props.theme.colorPalette.primaryColor};
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  margin-top: 16px;
  cursor: pointer;
  transition: background 0.2s;
  box-shadow: 0 2px 8px rgba(24, 29, 39, 0.04);
  &:hover {
    background: ${(props) => props.theme.colorPalette.primaryColor};
    filter: brightness(0.9);
  }
`;
